import { CodeBook, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import {
  CodeBookPagedFilter,
  HierarchicalCodeBookPagedFilter,
  HierarchicalCodeBook,
  GrandParentCodeBookPagedFilter,
  GreatGrandParentCodeBookPagedFilter,
} from "../../models";

const apiUrlPrefix: string = "geography";

export const getCountryList = async () => {
  return api.get(`${apiUrlPrefix}/countries`) as Promise<CodeBook[]>;
};

export const getCountyList = async () => {
  return api.get(`${apiUrlPrefix}/counties`) as Promise<CodeBook[]>;
};

export const searchMunicipalities = async (
  search: HierarchicalCodeBookPagedFilter
) => {
  return api.post(`${apiUrlPrefix}/municipalities`, search) as Promise<
    PagedResult<HierarchicalCodeBook>
  >;
};

export const searchTowns = async (search: GrandParentCodeBookPagedFilter) => {
  return api.post(`${apiUrlPrefix}/towns`, search) as Promise<
    PagedResult<HierarchicalCodeBook>
  >;
};

export const searchStreets = async (
  search: GreatGrandParentCodeBookPagedFilter
) => {
  return api.post(`${apiUrlPrefix}/streets`, search) as Promise<
    PagedResult<HierarchicalCodeBook>
  >;
};

export const searchHouseNumbers = async (
  hierarchicalCodeBookFilter: HierarchicalCodeBookPagedFilter
) => {
  return api.post(
    `${apiUrlPrefix}/house-numbers`,
    hierarchicalCodeBookFilter
  ) as Promise<PagedResult<HierarchicalCodeBook>>;
};
